import React, { useState } from "react";
import "./homeVideos.css";

const videoData = [
  {
    id: 1,
    title: "Top 5 Destinations to Visit This Year",
    videoId: "KBNHqI4kono",
  },
  {
    id: 2,
    title: "Exploring Famous World Heritage Sites",
    videoId: "KBNHqI4kono",
  },
  {
    id: 3,
    title: "Travel Safety Tips for Adventurers",
    videoId: "KBNHqI4kono",
  },
];



const HomeVideos = () => {
  const [activeVideo, setActiveVideo] = useState(null);

  return (
    <section className="home-videos">
      <div className="video-section-header text-center">
        <h2 className="section-title">Crafted for Meaningful Travel</h2>
        <p className="section-subtitle">
          Every journey thoughtfully shaped to feel personal and unforgettable.
        </p>
      </div>

      <div className="video-grid">
        {videoData.map((video) => (
          <div className="video-card" key={video.id}>
            {activeVideo === video.id ? (
              <iframe
                src={`https://www.youtube.com/embed/${video.videoId}?autoplay=1&rel=0`}
                title={video.title}
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              />
            ) : (
              <div
                className="thumbnail"
                onClick={() => setActiveVideo(video.id)}
              >
                <img
                  src={`https://img.youtube.com/vi/${video.videoId}/hqdefault.jpg`}
                  alt={video.title}
                />

                {/* YouTube style play button */}
                <div className="yt-play-btn">
                  <span></span>
                </div>
              </div>
            )}

            <h5 className="video-title">{video.title}</h5>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HomeVideos;
